import React from 'react';

/**
 * Plain text/number input (and textarea). Formerly a voice-to-text field with a
 * mic button — the speech feature was removed app-wide, so this is now just a
 * styled passthrough input. Kept under the same name + prop API so the ~11 call
 * sites don't need to change.
 */
const VoiceInput = ({
  value = '',
  onChange,
  placeholder = '',
  type = 'text',
  required = false,
  className = '',
  disabled = false,
  name,
  id,
  step,
  min,
  max,
  rows,
  isTextarea = false,
}) => {
  const inputClasses = `w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent ${className}`;

  if (isTextarea) {
    return (
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows || 3}
        className={inputClasses}
      />
    );
  }

  return (
    <input
      id={id}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      step={step}
      min={min}
      max={max}
      className={inputClasses}
    />
  );
};

export default VoiceInput;
